import { KolumnaEdycjiMapowania } from "./kolumnaEdycjiMapowania";

export class EdytujMapowanieModel {
    projektId: string;
    lokalizacjaKolumnaEwidencjiId: string;
    lokalizacjaKolumnaLokalizacja: string;
    mapowania: Array<KolumnaEdycjiMapowania> = new Array();
    zgodaNaPonowneParowanie: boolean;
}